/** Shared Dev specific tenant settings */

const uatConfig = {
  segment: {
    enabled: false,
    publicKey: 'LR3TCDRu7vPZfty8FPZsg4Oe1WTmpAtt'
  },
  rudderstack: {
    enabled: true,
    publicKey: '2A59r5cgf9ZJnZBtj6kggLgmQKM'
  },
  sentry: {
    projectId: 237611,
    publicKey: 'b63907577f9c4091895c49cc963fa8e4',
    dsn: 'https://b63907577f9c4091895c49cc963fa8e4@o104929.ingest.sentry.io/237611'
  }
};

module.exports = uatConfig;
